import React from 'react';
import { useState } from 'react';
interface Props {
  color?: string;
}

const LinkOutIcon = ({ color }: Props) => {
  const [color1, setColor] = useState('#A8B2D1');
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setColor('#64FFDA')}
        onMouseLeave={() => setColor('#A8B2D1')}
      >
        <path
          d="M11.1437 9.85769L11.1434 9.85744L11.1366 9.86527C11.0193 10.0003 10.9572 10.1746 10.9628 10.3534C10.9684 10.5323 11.0413 10.7024 11.1669 10.8298C11.2925 10.9572 11.4615 11.0325 11.6403 11.0406C11.819 11.0488 11.9942 10.9891 12.1309 10.8737L12.1312 10.8741L12.1401 10.8652L19.7263 3.27898V6.92761H19.7263L19.7263 6.92995C19.7293 7.11676 19.8048 7.2951 19.9369 7.42721C20.069 7.55932 20.2473 7.63483 20.4341 7.63775V7.63777H20.4365C20.6248 7.63777 20.8055 7.56295 20.9386 7.42977C21.0718 7.29658 21.1466 7.11595 21.1466 6.92761V1.56126C21.1466 1.37291 21.0718 1.19228 20.9386 1.0591C20.8055 0.925919 20.6248 0.851099 20.4365 0.851099H15.0701C14.8818 0.851099 14.7012 0.925919 14.568 1.0591C14.4348 1.19228 14.36 1.37291 14.36 1.56126C14.36 1.74961 14.4348 1.93024 14.568 2.06342C14.7012 2.1966 14.8818 2.27142 15.0701 2.27142H18.7191L11.1437 9.85769Z"
          fill={color || color1}
          stroke={color || color1}
          stroke-width="0.3"
        />
        <path
          d="M17.583 21.15H17.5832C18.5289 21.1491 19.4356 20.773 20.1043 20.1043C20.773 19.4356 21.1491 18.5289 21.15 17.5832V17.583V10.8308C21.15 10.6425 21.0752 10.4619 20.942 10.3287C20.8088 10.1955 20.6282 10.1207 20.4398 10.1207C20.2515 10.1207 20.0709 10.1955 19.9377 10.3287C19.8045 10.4619 19.7297 10.6425 19.7297 10.8308V17.5828C19.7288 18.1519 19.5024 18.6975 19.1 19.1C18.6975 19.5024 18.1519 19.7288 17.5828 19.7297H4.4172C3.84807 19.7288 3.30249 19.5024 2.90005 19.1C2.49763 18.6975 2.27117 18.152 2.27032 17.5829C2.27032 17.5828 2.27032 17.5828 2.27032 17.5828V4.4172C2.27032 4.41718 2.27032 4.41715 2.27032 4.41712C2.27117 3.84802 2.49763 3.30247 2.90005 2.90005C3.30247 2.49763 3.84802 2.27117 4.41712 2.27032C4.41715 2.27032 4.41718 2.27032 4.4172 2.27032L11.1703 2.27032C11.3586 2.27032 11.5393 2.1955 11.6724 2.06232C11.8056 1.92914 11.8805 1.74851 11.8805 1.56016C11.8805 1.37181 11.8056 1.19118 11.6724 1.058C11.5393 0.924821 11.3586 0.85 11.1703 0.85L4.41698 0.85L4.41684 0.85C3.47114 0.850929 2.56444 1.22702 1.89573 1.89573C1.22702 2.56444 0.850929 3.47114 0.85 4.41684V4.41698L0.85 17.583L0.85 17.5832C0.850929 18.5289 1.22702 19.4356 1.89573 20.1043C2.56444 20.773 3.47114 21.1491 4.41684 21.15H4.41698H17.583Z"
          fill={color || color1}
          stroke={color || color1}
          stroke-width="0.3"
        />
      </svg>
    </>
  );
};

export default LinkOutIcon;
